var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { MarkdownContent } from './markdown-content';
var cls = classNames('type-writer-effect');
export var WordWriterEffectDefaultProps = {
  description: 'This is a text writer effect.',
  delay: 0.15
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var WordBlockContentStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    opacity: 0;\n    display: inline-block;\n    margin-right: 0.25em;\n\n    @keyframes fadeIn {\n      from { opacity: 0; }\n      to { opacity: 1; }\n    }\n\n    animation: fadeIn 0.5s ease-in forwards;\n\n  ", "\n  "], ["\n    opacity: 0;\n    display: inline-block;\n    margin-right: 0.25em;\n\n    @keyframes fadeIn {\n      from { opacity: 0; }\n      to { opacity: 1; }\n    }\n\n    animation: fadeIn 0.5s ease-in forwards;\n\n  ", "\n  "])), function (_a) {
    var index = _a.index,
      delay = _a.delay;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    animation-delay: ", "s;\n  "], ["\n    animation-delay: ", "s;\n  "])), index * delay);
  })
});
// -------- Components -------->
var My = {
  NAME: 'WordWriterEffect',
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  WordBlockContent: styled(MarkdownContent)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), WordBlockContentStyles)
};
export var WordWriterEffect = function (props) {
  var _a = useComponentProps(My.NAME, WordWriterEffectDefaultProps, props),
    className = _a.className,
    children = _a.children,
    description = _a.description,
    delay = _a.delay;
  var splitText = description.split(' ');
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, splitText.map(function (word, index) {
    return word === '<br>' ? React.createElement("br", {
      key: index
    }) : React.createElement(My.WordBlockContent, {
      key: index,
      delay: delay,
      index: index,
      text: word
    });
  }));
};
WordWriterEffect.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;